module.exports = __webpack_public_path__ + "static/media/logo-icon-white.9ac5c052.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo/logo-icon-white.svg
// module id = 391
// module chunks = 0